import { IMG_URL } from "configs";
import { motion } from "framer-motion";
import { useAnime } from "./Anime";

export default function Image({
  src,
  alt,
  className,
  anime,
  transition = "pop",
  delay = 0,
  duration,
  ...props
}) {
  const animation = useAnime({ anime, transition, delay, duration });

  return (
    <motion.img
      src={`${IMG_URL}/${src}`}
      alt={alt}
      className={className}
      {...props}
      {...animation}
    />
  );
}
